/*eslint-disable*/
import React from 'react';
import './footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer_container container">
      <h1 className="footer_title">Basit</h1>
      <ul className="footer_list">
        <li>
          <a href="#about" className="footer_link">
            About
          </a>
        </li>
        <li>
          <a href="#portfolio" className="footer_link">
            Projects
          </a>
        </li>
        <li>
          <a href="#skills" className="footer_link">
            Skills
          </a>
        </li>
      </ul>

      <div className="footer-social">
        <a href="https://www.linkedin.com/in/basit-ali-jobs" className="footer_social-link" target="_blank" rel="noreferrer">
          <i className="bx bxl-linkedin" />
        </a>
        <a href="https://github.com/basitali111" className="footer_social-link" target="_blank" rel="noreferrer">
          <i className="bx bxl-github" />
        </a>

        <a href="https://medium.com/@allahbadshah148" className="footer_social-link" target="_blank" rel="noreferrer">
          <i className="bx bxl-medium" />
        </a>
      </div>
      <span className="footer_copy">
        &copy; All rights reserved | Designed by Basit
      </span>
    </div>
  </footer>
);

export default Footer;
